module.exports = __webpack_public_path__ + "static/media/alert_selected_hover.d5915513.svg";